/* global __CLIENT__ */

/**
 * Replacement for the react-twitter-widgets package
 *
 * Based on the twitter docs (https://developer.twitter.com/en/docs/twitter-for-websites/embedded-tweets/guides/embedded-tweet-javascript-factory-function)
 *
 * I Created our own solution as we only use embedded tweets and nothing of the other widgets
 * and because the package loads the twitter stuff ALWAYS, even if no Tweet is on the page
 * and it adds some 40k to the vendors bundle...
 */

import React, {
    useCallback, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const loadingStyles = {
    padding: '20px',
    border: 'solid 1px #ccd6dd',
    borderRadius: '15px',
    width: '100%',
    maxWidth: '550px',
    margin: '10px auto',
    textAlign: 'center',
};

const Tweet = ({ tweetId }) => {
    const divId = `twttr-${tweetId}`;
    const [loading, setLoading] = useState(true);

    const createTweet = useCallback((_tweetId) => {
        if (!window.twttr || !window.twttr.widgets) {
            // eslint-disable-next-line no-console
            return console.error('Twitter widgets not loaded');
        }

        return window.twttr.widgets.createTweet(
            _tweetId,
            document.getElementById(divId),
            {
                // align: 'center',
                // theme: 'dark',
            },
        ).then(() => setLoading(false));
    }, [divId]);

    useEffect(() => {
        if (__CLIENT__ && !window.twttr) {
            const scriptId = 'twitter-wjs';
            const twitterScriptElement = document.getElementById(scriptId);

            if (twitterScriptElement) {
                // this is the case if the script was already injected but did not yet load
                // this can happen if there is more than one tweet on the same page
                // in this case, append an onload eventlistener to the already existent script tag and create the tweet once the script finished loading
                twitterScriptElement.addEventListener('load', () => createTweet(tweetId));

                return;
            }

            // if the twitter stuff is not yet loaded (or loading), inject a script to load it
            const script = document.createElement('script');

            script.id = scriptId;

            script.src = '//platform.twitter.com/widgets.js';

            script.async = true;

            script.onload = () => createTweet(tweetId);

            document.body.appendChild(script);
        }

        if (__CLIENT__ && window.twttr && window.twttr.widgets) {
            // if the twitter stuff is already loaded, just create the tweet
            createTweet(tweetId);
        }
    }, [createTweet, tweetId]);

    return (
        <div>
            {loading && <div style={loadingStyles}>carregando Tweet...</div>}
            <div id={divId} />
        </div>
    );
};

Tweet.propTypes = exact({
    tweetId: PropTypes.string.isRequired,
});

export default Tweet;
